import { getFullTranslations } from './util';

export const nlTranslationMessages = getFullTranslations('nl');
